import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Form, FormInput, Submit } from "../../../components/form";
import FormSelect from "../../../components/form/FormSelect";
import ImagePicker from "../../../components/ImagePicker";
import useBusinesses from "../../../hooks/api/useBusinesses";
import { currencyFormatter } from "../../../utils/func";
import { links } from "../../../utils/routes";
import svg from "../../../utils/svg";
import { conceptsAndMenus, timing } from "../../../utils/vars";
import { conceptSchema } from "../../../validators/icart";
import Table from "../../table/Table";
import CheckBox from "../../CheckBox";

export default function ViewMenu() {
  const {
    state: { data },
  } = useLocation();
  const navigate = useNavigate();
  const [active, setActive] = useState(data.active);
  const [selectedImage, setSelectedImage] = useState(null);
  const { isLoading, getMenuIngredients, menuIngredients, updateMenu } =
    useBusinesses();
  const ingshead = [
    {
      title: "#",
      target: "#",
      className: "count",
    },
    {
      title: "Name",
      target: "name",
    },
    {
      title: "Price",
      target: "price",
      render: (v) => currencyFormatter(v),
    },
    {
      title: "Status",
      target: "active",
      render: (value) => (
        <span className={`status ${value}`}>
          {value ? "ACTIVE" : "NOT ACTIVE"}
        </span>
      ),
    },
    {
      title: "Actions",
      target: "_id",
      render: (id) => (
        <button
          className="action flex align-center"
          onClick={() =>
            navigate(
              links.conceptsAndMenus.view(conceptsAndMenus.ingredient, id),
              {
                state: { data: menuIngredients.filter((a) => a._id == id)[0] },
              }
            )
          }
        >
          {svg.eye()} <span className="f700">VIEW</span>
        </button>
      ),
    },
  ];
  useEffect(() => {
    getMenuIngredients(data._id);
  }, []);

  return (
    <div>
      <h2>View Menu</h2>
      <br />
      <Form
        validationSchema={conceptSchema}
        onSubmit={(v) => {
          updateMenu(data._id, { ...v, active }, selectedImage);
        }}
        initialValues={{
          name: data.name,
          price: data.price,
        }}
      >
        <FormInput name="name" placeholder="Name" />
        <FormInput name="price" type="number" placeholder="Price" />

        <ImagePicker
          initial={data.imageUrl}
          onSelect={setSelectedImage}
          placeholder="Upload Image"
        />
        <br />
        <div className="flex align-center">
          <CheckBox onChange={setActive} value={active} />
          <span style={{ marginLeft: 5 }}>Active</span>
        </div>
        <br />
        <Submit
          loading={isLoading}
          disabled={isLoading}
          className="btn-submit"
          title="Save and Update"
        />
        <br />
        <br />
        <Table
          showSearch={false}
          head={ingshead}
          title="Menu Ingredents"
          btn={{
            title: "Add",
            className: "btn-view",
            onClick: () =>
              navigate(
                links.conceptsAndMenus.append(
                  conceptsAndMenus.ingredient,
                  data._id
                ),
                {
                  state: { id: data._id, data: menuIngredients },
                }
              ),
          }}
          data={menuIngredients}
        />
      </Form>
    </div>
  );
}
